<div class="container mt-5">
  <div class="d-flex flex-column">
    <app-tok-header
      [title]="
        'Before we finalise the transfer, please take a moment to verify and complete your pet’s information.'
      "
    ></app-tok-header>

    <form #editPetForm="ngForm" (ngSubmit)="save()" class="d-flex flex-column align-items-center">
      <div class="details-container">
        <div class="details-container-content">
          <div>
            <h3 class="text-center">Pet details</h3>
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="tokPetChipNumber">Chip number</label>
            <img src="assets/images/tokIcons/search.svg" alt="search-icon" class="input-icon" />

            <input
              #petChipNumber="ngModel"
              class="form-control input-field-disabled"
              id="tokPetChipNumber"
              name="tokPetChipNumber"
              [(ngModel)]="pet.chipNumber"
              placeholder="Chip Number"
              type="text"
              required
              disabled
            />
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="petName">Pet name</label>
            <fa-icon
            [icon]="['fas', 'info-circle']"
            class="clickable-tag ms-1"
            ngbTooltip="If you have changed your pet’s name, you can edit this once the pet is transferred to your account"
            placement="right"
          ></fa-icon>
            <img src="assets/images/tokIcons/pin.svg" alt="search-icon" class="input-icon" />

            <input
              #petName="ngModel"
              class="form-control input-field"
              id="petName"
              name="petName"
              [(ngModel)]="pet.name"
              placeholder="Your pet's name"
              type="text"
              required
            />
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="petSex">Sex</label>
            <img src="assets/images/tokIcons/gender.svg" alt="search-icon" class="input-icon" />

            <select
              #petSex="ngModel"
              class="form-control form-select input-field-disabled"
              [class.is-invalid]="petSex.touched && petSex.invalid"
              id="petSex"
              name="petSex"
              [(ngModel)]="pet.gender"
              disabled
              required
            >
              <option [ngValue]="petGender.Male">Male</option>
              <option [ngValue]="petGender.Female">Female</option>
            </select>
            <div *ngIf="petSex.invalid && petSex.errors.required" class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="species">Species</label>
            <img src="assets/images/tokIcons/pet.svg" alt="search-icon" class="input-icon" />

            <select
              #petSpecies="ngModel"
              class="form-control form-select input-field-disabled"
              [class.is-invalid]="petSpecies.touched && petSpecies.invalid"
              id="petSpecies"
              name="petSpecies"
              [(ngModel)]="selectedSpecies"
              (ngModelChange)="updateBreedsList()"
              disabled
              required
            >
              <option [ngValue]="null" disabled>
                {{ loadingSpecies ? 'Loading...' : 'Please select...' }}
              </option>
              <option *ngFor="let species of speciesList" [ngValue]="species">
                {{ species.description }}
              </option>
            </select>
            <div *ngIf="petSpecies.invalid && petSpecies.errors.required" class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="petBreed">Breed</label>
            <img src="assets/images/tokIcons/breed.svg" alt="search-icon" class="input-icon" />

            <input
              #petBreed="ngModel"
              #petBreedTypeahead="ngbTypeahead"
              class="form-control input-field-disabled"
              [class.is-invalid]="petBreed.touched && petBreed.invalid"
              id="petBreed"
              name="petBreed"
              [(ngModel)]="pet.breed"
              [ngbTypeahead]="searchBreed"
              [disabled]="!pet.species || loadingSpecies || loadingBreeds"
              [placeholder]="pet.species ? 'Please enter the breed...' : 'Select species first...'"
              [editable]="false"
              (focus)="focus$.next($any($event).target.value)"
              (click)="click$.next($any($event).target.value)"
              placement="bottom-left"
              required
              type="text"
            />

            <div *ngIf="petBreed.invalid && petBreed.errors.required" class="invalid-feedback">
              Please select a breed from the list.
            </div>
          </div>
        </div>

        <hr class="divider" />

        <div class="details-container-content">
          <div>
            <h3 class="text-center">Your details</h3>
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="firstName">Name*</label>
            <img src="assets/images/tokIcons/person.svg" alt="search-icon" class="input-icon" />

            <input
              #firstName="ngModel"
              class="form-control input-field"
              [class.is-invalid]="firstName.touched && !firstName.valid"
              id="firstName"
              name="firstName"
              [(ngModel)]="keeperDetailModel.firstName"
              placeholder="Your first name"
              (blur)="keeperDetailModel.firstName = keeperDetailModel.firstName.trim()"
              required
              type="text"
            />
            <div *ngIf="firstName.errors && firstName.errors.required" class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="lastName">Last name*</label>
            <img src="assets/images/tokIcons/person.svg" alt="search-icon" class="input-icon" />

            <input
              #lastName="ngModel"
              class="form-control input-field"
              [class.is-invalid]="lastName.touched && !lastName.valid"
              id="lastName"
              name="lastName"
              [(ngModel)]="keeperDetailModel.lastName"
              placeholder="Your last name"
              (blur)="keeperDetailModel.lastName = keeperDetailModel.lastName.trim()"
              required
              type="text"
            />
            <div *ngIf="lastName.errors && lastName.errors.required" class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
          </div>

          <div class="mb-3 input-container">
            <label class="form-label" for="phoneNumber">Phone number*</label>
            <img src="assets/images/tokIcons/phone.svg" alt="search-icon" class="input-icon" />

            <input
              #phoneNumber="ngModel"
              class="form-control input-field"
              [class.is-invalid]="phoneNumber.touched && !phoneNumber.valid"
              id="phoneNumber"
              name="phoneNumber"
              [(ngModel)]="keeperDetailModel.mainPhoneNumber"
              placeholder="Your phone number"
              (blur)="keeperDetailModel.mainPhoneNumber = keeperDetailModel.mainPhoneNumber.trim()"
              [pattern]="validationPatterns.telephone"
              required
              type="text"
            />
            <div *ngIf="phoneNumber.errors && phoneNumber.errors.required" class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
            <div
              *ngIf="
                phoneNumber.errors && phoneNumber.errors.pattern && !phoneNumber.errors.minlength
              "
              class="invalid-feedback"
            >
              {{ errorStrings.telephoneInvalid }}
            </div>
          </div>

          <div class="mb-4 input-container">
            <label class="form-label" for="postcodeCheck">Start typing your postcode</label>
            <img
              src="assets/images/tokIcons/postal-code.svg"
              alt="search-icon"
              class="input-icon"
            />

            <input
              class="form-control input-field"
              id="postcodeCheck"
              name="postcodeCheck"
              [(ngModel)]="postcodeCheck"
              placeholder="Your postcode"
              (input)="onPostCodeCheckChanges($event)"
              required
              type="text"
            />

            <div *ngIf="isPostcodeInvalid" class="postcode-invalid">
              The provided postcode is invalid!
            </div>

            <div *ngIf="addressesSelectList.length > 0" class="mb-3 input-container">
              <label class="form-label" for="title">Select your address</label>
              <img
                src="assets/images/tokIcons/postal-address.svg"
                alt="search-icon"
                class="input-icon"
              />

              <select
                class="form-control form-select input-field"
                id="selectedAddress"
                name="selectedAddress"
                [(ngModel)]="selectedAddress"
                (ngModelChange)="onSelectAddressChanged($event)"
              >
                <option [ngValue]="null" disabled>Select address...</option>
                <option *ngFor="let addressOption of addressesSelectList" [ngValue]="addressOption">
                  {{ getAddressLabel(addressOption) }}
                </option>
              </select>
            </div>
          </div>

          <div class="mb-3 input-container">
            <img
              src="assets/images/tokIcons/postal-address.svg"
              alt="search-icon"
              class="input-icon-without-label"
            />

            <input
              #addressLine1="ngModel"
              class="form-control input-field"
              [class.is-invalid]="addressLine1.touched && !addressLine1.valid"
              id="addressLine1"
              name="addressLine1"
              [(ngModel)]="addressModel.addressLine1"
              placeholder="Address line 1"
              (blur)="addressModel.addressLine1 = addressModel.addressLine1.trim()"
              required
              type="text"
            />
            <div
              *ngIf="addressLine1.errors && addressLine1.errors.required"
              class="invalid-feedback"
            >
              {{ errorStrings.required }}
            </div>
          </div>

          <div class="mb-3 input-container">
            <img
              src="assets/images/tokIcons/town-flag.svg"
              alt="search-icon"
              class="input-icon-without-label"
            />

            <input
              #townPerCity="ngModel"
              class="form-control input-field"
              [class.is-invalid]="townPerCity.touched && !townPerCity.valid"
              id="townPerCity"
              name="townPerCity"
              [(ngModel)]="addressModel.townPerCity"
              placeholder="Town/City"
              required
              type="text"
            />
            <div
              *ngIf="townPerCity.invalid && townPerCity.errors.required"
              class="invalid-feedback"
            >
              {{ errorStrings.required }}
            </div>
          </div>
        </div>
      </div>

      <div class="mb-2 text-center marketing-text">
        <div class="justify-text">
          If any of these details don’t look quite right, please call our Pet Protection team on 0330 9128077 and we can assist you further.<br/><br/>
          By creating and account you agree to identibase’s
          <a routerLink="/terms-and-conditions" target="_blank">terms & conditions</a>
          and
          <a routerLink="/privacy" target="_blank">privacy policy.</a>
        </div>
      </div>

      <div ngbAccordion [closeOthers]="true" class="marketing-form mb-3">
        <div ngbAccordionItem id="alert" title="Select communication preferences">
          <div ngbAccordionHeader>
            <div class="card border-0">
              <button class="toggle-button card-header" ngbAccordionButton>
                you must choose your marketing preferences here to complete registration
              </button>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <span [formGroup]="communicationForm">
                  <div class="mb-3">
                    <label class="form-check-label d-flex justify-content-center align-items-center">
                      <input
                        class="me-3 communication-checkbox internal-communication-checkbox"
                        id="subToAllInternalCommunication"
                        name="subToAllInternalCommunication"
                        formControlName="subscribeToAllInternalCommunication"
                        type="checkbox"
                      />
                      <div class="justify-text">
                        We would love to keep you up to date with all our latest news, offers, useful
                        pet tips and pet related content. Tick the box if you
                        <strong>do not want</strong>
                        to be contacted.
                      </div>
                    </label>
                  </div>
                  <div class="justify-text">
                    <p>
                      We have partnered with carefully selected 3rd parties so that we can send you
                      exclusive offers and promotions on pet food, pet accessories, pet insurance and
                      other pet related services by email and SMS.
                    </p>
                  </div>
                  <div formGroupName="thirdPartySubscribeOptionSelectGroup">
                    <div class="mb-0">
                      <label class="form-check-label d-flex align-items-center">
                        <input
                          class="me-3 communication-checkbox"
                          id="subscribeToAllThirdParty"
                          name="subscribeToAllThirdParty"
                          formControlName="subscribeToAllThirdParty"
                          (change)="onSubscribeOptionChanged($event)"
                          type="checkbox"
                        />
                        <span>
                          Tick here if you
                          <strong>do want</strong>
                          to receive this or
                        </span>
                      </label>
                    </div>
                    <div class="mb-0">
                      <label class="form-check-label d-flex align-items-center">
                        <input
                          class="me-3 communication-checkbox"
                          id="unsubscribeFromAllThirdParty"
                          name="unsubscribeFromAllThirdParty"
                          formControlName="unsubscribeFromAllThirdParty"
                          (change)="onSubscribeOptionChanged($event)"
                          type="checkbox"
                        />
                        <span>
                          Tick here if you
                          <strong>do not want</strong>
                          to receive this.
                        </span>
                      </label>
                    </div>
                    <span
                      *ngIf="
                        thirdPartyCheckboxStateChanged &&
                        communicationForm.controls['thirdPartySubscribeOptionSelectGroup'].errors
                      "
                      class="invalid-checkboxes"
                    >
                      One of the two options is required
                    </span>
                    <div class="justify-text mt-2">
                      <p>We do not pass on your personal data to any 3rd parties.</p>
                    </div>
                    <div class="mb-0 mt-3">
                      <label class="form-label justify-text mb-0">
                        You can change your communication options or unsubscribe at any time by updating
                        your account preferences in your account or by contacting us.
                      </label>
                    </div>
                  </div>
                </span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-success text-white btn-lg btn-block mt-2 mb-5 update-details-button"
        [disabled]="!thirdPartyCheckboxStateChanged || !editPetForm.valid"
      >
        <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
        Update details
      </button>
    </form>
  </div>
</div>
